import api from "./api";

export interface TipoTarefaItem {
  id: string;
  texto: string;
  ordem: number;
}

export interface TipoTarefa {
  id: string;
  slug: string;
  label: string;
  cor: string | null;
  icone: string;
  ativo: boolean;
  ordem: number;
  /** Esforço padrão (horas decimais) pré-preenchido ao criar tarefa. CARDS 1. */
  horasEstimadasPadrao: number | null;
  /** MELHORIA 8 — papéis do catálogo unificado. vendavel: aparece no seletor de
   *  itens de contrato; usadoComoTipo: aparece no dropdown de tipo da tarefa. */
  vendavel: boolean;
  usadoComoTipo: boolean;
  /** MELHORIA 21 — categoria no relatório de entregas (Artes/Vídeos/Captações…). */
  categoriaRelatorio?: string | null;
  /** false = a quantidade do item NÃO é quantidade de peças (ex.: contrato por
   *  pontos). Fica fora da previsão de peças do painel consolidado. */
  contaComoPeca?: boolean;
  itensChecklist?: TipoTarefaItem[];
}

/** Média histórica de esforço de um tipo (dica ao criar tarefa). */
export interface MediaTipoTarefa {
  amostras: number;
  comTempo: number;
  mediaExecutadaMs: number | null;
  mediaEstimadaH: number | null;
}

export async function listarTiposTarefa(opts?: { todos?: boolean }) {
  const r = await api.get(`/tipos-tarefa${opts?.todos ? "?todos=1" : ""}`);
  return r.data.data as TipoTarefa[];
}

export async function criarTipoTarefa(dados: {
  label: string;
  slug?: string;
  cor?: string | null;
  icone?: string;
  ordem?: number;
  ativo?: boolean;
  horasEstimadasPadrao?: number | null;
  vendavel?: boolean;
  usadoComoTipo?: boolean;
  categoriaRelatorio?: string | null;
  contaComoPeca?: boolean;
}) {
  const r = await api.post("/tipos-tarefa", dados);
  return r.data.data as TipoTarefa;
}

export async function atualizarTipoTarefa(
  id: string,
  dados: Partial<{ label: string; cor: string | null; icone: string; ativo: boolean; ordem: number; horasEstimadasPadrao: number | null; vendavel: boolean; usadoComoTipo: boolean; categoriaRelatorio: string | null; contaComoPeca: boolean }>,
) {
  const r = await api.patch(`/tipos-tarefa/${id}`, dados);
  return r.data.data as TipoTarefa;
}

export async function mediaTipoTarefa(id: string) {
  const r = await api.get(`/tipos-tarefa/${id}/media`);
  return r.data.data as MediaTipoTarefa;
}

export async function definirChecklistTipoTarefa(id: string, itens: string[]) {
  const r = await api.put(`/tipos-tarefa/${id}/checklist`, { itens });
  return r.data.data as TipoTarefa;
}

export async function excluirTipoTarefa(id: string) {
  await api.delete(`/tipos-tarefa/${id}`);
}
